import { BsQuestionCircle } from "react-icons/bs";
import { FaHandshake } from "react-icons/fa";
import { MdOutlineCelebration } from "react-icons/md";
import { BiNews } from "react-icons/bi";
import { HashLink } from "react-router-hash-link";
import {
  BsFillPersonFill,
  BsFillHouseFill,
  BsFillWalletFill,
  BsBootstrapFill,
} from "react-icons/bs";
import {IoCallOutline} from "react-icons/io5"
import { FaBloggerB, FaHome, FaTicketAlt, FaUnlockAlt } from "react-icons/fa";
import { MdOutlineLocalOffer } from "react-icons/md";
import { RiFileCopy2Line, RiLockPasswordFill } from "react-icons/ri";
import { TiCancel } from "react-icons/ti";
import { AiFillHeart, AiFillInfoCircle, AiFillCar } from "react-icons/ai";
import { MdLogout } from "react-icons/md";
import Account from "../assets/Profile.png";
import AccountWhite from "../assets/Profile White@4x.png"
import transactionHistory from "../assets/Transaction.png"
import transactionHistoryWhite from "../assets/Transaction White@4x.png"
import MyBookings from "../assets/My Booking.png"
import MyBookingsWhite from "../assets/My Booking White@4x.png"
import Offers from "../assets/Offers.png"
import OffersWhite from "../assets/Offer White@4x.png"
import ContactSupport from "../assets/Contact.png"
import ContactSupportWhite from "../assets/Contact White@4x.png"
import TermsOfService from "../assets/Terms.png"
import TermsOfServiceWhite from "../assets/Terms White@4x.png"
import PrivacyPolicy  from "../assets/Privacy.png"
import PrivacyPolicyWhite  from "../assets/Privacy White@4x.png"
import Logout from "../assets/Logout.png"
import LogoutWhite from "../assets/Logou White@4x.png"
import HowItWorks from "../assets/How its work@4x.png"
import Home from "../assets/Home@4x.png"
import BecomeAPatner from "../assets/Partner@4x.png"




export const SIDE_NAV_LIST = [
  {
    title: "Account",
    link: "/profile/account",
    icon1: <img src={Account} className="text-[24px] mr-2" />,
    icon2: <img src={AccountWhite} className="text-[24px] mr-2" />,

  },
  //{
  //  title: "My Vehicle",
  //  link: "/profile/vehicle",
  //  icon: <AiFillCar className="text-[24px] mr-2" />,
  //},
  {
    title: "My Transactions",
    link: "/profile/Wallet-histroy",
    icon1: <img src={transactionHistory} className="text-[24px] mr-2" />,
    icon2: <img src={transactionHistoryWhite} className="text-[24px] mr-2" />,
  },
  {
    title: "My Bookings",
    link: "/profile/booking",
    icon1: <img src={MyBookings} className="text-[24px] mr-2" />,
    icon2: <img src={MyBookingsWhite} className="text-[24px] mr-2" />,
  },
  //{
  //  title: "Favourites",
  //  link: "/profile/favourites",
  //  icon: <AiFillHeart className="text-[24px] mr-2" />,
  //},
  {
    title: "Offers",
    link: "/profile/offers",
    icon1: <img src={Offers} className="text-[24px] mr-2" />,
    icon2: <img src={OffersWhite} className="text-[24px] mr-2" />,
  },
  {
    title: "Contact Support",
    link: "/profile/contact-support",
    icon1: <img src={ContactSupport} className="text-[24px] mr-2" />,
    icon2: <img src={ContactSupportWhite} className="text-[24px] mr-2" />,
  },
  {
    title: "Terms of Service",
    link: "/profile/terms-and-condition",
    icon1: <img src={TermsOfService} className="text-[24px] mr-2" />,
    icon2: <img src={TermsOfServiceWhite} className="text-[24px] mr-2" />,
  },
  {
    title: "Privacy Policy",
    link: "/profile/privacy-policy",
    icon1: <img src={PrivacyPolicy} className="text-[24px] mr-2" />,
    icon2: <img src={PrivacyPolicyWhite} className="text-[24px] mr-2" />,
  },
  {
    title: "Logout",
    link: "/logout",
    icon1: <img src={Logout} className="text-[24px] mr-2" />,
    icon2: <img src={LogoutWhite} className="text-[24px] mr-2" />,
  },
];

export const HEADER_ITEMS = [
  {
    type: "link",
    title: "Home",
    link: "/",
    icon: <img src={Home} className="text-[24px] mr-2" />,
  },
  //{
  //  type: "link",
  //  title: <HashLink smooth to="/#aboutus">About Us</HashLink>,
  //  link: "/#aboutus",
  //  icon: <MdOutlineCelebration className="text-[24px] mr-2" />,
  //},
  //{
  //  type: "link",
  //  title: <HashLink smooth to="/#services">Our Services</HashLink>,
  //  link: "/#services",
  //  icon: <MdOutlineCelebration className="text-[24px] mr-2" />,
  //},
  //{
  //  type: "link",
  //  title: <HashLink smooth to="/#benefits">BENEFITS</HashLink>,
  //  link: "/#benefits",
  //  icon: <MdOutlineCelebration className="text-[24px] mr-2" />,
  //},
  {
    type: "link",
    title: <HashLink smooth to="/#how-it-works">How it Works</HashLink>,
    link: "/#howItWorks",
    icon: <img src={HowItWorks} className="text-[24px] mr-2" />,
  },
  {
    type: "link",
    title: <HashLink smooth to="/#become-a-partner">Become a Partner</HashLink>,
    link: "/#become-a-partner",
    icon: <img src={BecomeAPatner} className="text-[24px] mr-2" />,
  },
 // {
  //  type: "link",
  //  title: <HashLink smooth to="/#latest-news">LATEST NEWS</HashLink>,
  //  link: "/#latest-news",
  //  icon: <BiNews className="text-[24px] mr-2" />,
  //},

];

export const ALL_SIDE_NAV_LIST = [
  {
    type: "link",
    title: "Home",
    link: "/",
    icon: <img src={Home} className="text-[24px] mr-2" />,
  },
  //{
  //  type: "link",
  //  title: <HashLink smooth to="/#aboutus">About Us</HashLink>,
  //  link: "/#aboutus",
  //  icon: <MdOutlineCelebration className="text-[24px] mr-2" />,
  //},
  {
    type: "link",
    title: <HashLink smooth to="/#how-it-works">How it Works</HashLink>,
    link: "/#how-it-works",
    icon: <img src={HowItWorks} className="text-[24px] mr-2" />,
  },
  {
    type: "link",
    title: <HashLink smooth to="/#become-a-partner">Become a Partner</HashLink>,
    link: "/#become-a-partner",
    icon: <img src={BecomeAPatner} className="text-[24px] mr-2" />,
  },
  //{
  //  type: "link",
  //  title: <HashLink smooth to="/#services">Our Services</HashLink>,
  //  link: "/#services",
  //  icon: <FaHandshake className="text-[24px] mr-2" />,
  //},
  //{
  //  type: "link",
  //  title: <HashLink smooth to="/#latest-news">LATEST NEWS</HashLink>,
  //  link: "/#latestNews",
  //  icon: <BiNews className="text-[24px] mr-2" />,
 // },
  {
    title: "Account",
    link: "/profile/account",
    icon: <img src={Account} className="text-[24px] mr-2" />,
  },
  //{
  //  title: "My Vehicle",
  //  link: "/profile/vehicle",
  //  icon: <AiFillCar className="text-[24px] mr-2" />,
  //},
  {
    title: "My Transactions",
    link: "/profile/Wallet-histroy",
    icon: <img src={transactionHistory} className="text-[24px] mr-2" />,
  },
  {
    title: "My Bookings",
    link: "/profile/booking",
    icon: <img src={MyBookings} className="text-[24px] mr-2" />,
  },
  //{
  //  title: "Favourites",
  //  link: "/profile/favourites",
  //  icon: <AiFillHeart className="text-[24px] mr-2" />,
  //},
  {
    title: "Offers",
    link: "/profile/offers",
    icon:<img src={Offers} className="text-[24px] mr-2" />,
  },
  {
    title: "Contact Support",
    link: "/profile/contact-support",
    icon: <img src={ContactSupport} className="text-[24px] mr-2" />,
  },
  {
    title: "Terms of Service",
    link: "/profile/terms-and-condition",
    icon: <img src={TermsOfService} className="text-[24px] mr-2" />,
  },
  {
    title: "Privacy Policy",
    link: "/profile/privacy-policy",
    icon: <img src={PrivacyPolicy} className="text-[24px] mr-2" />,
  },
  {
    title: "Logout",
    link: "",
    icon: <img src={Logout} className="text-[24px] mr-2" />,
  },
];
